/* Island Living motion system: scroll reveals for island-page decor ONLY.
 * Product cards and other store content are never armed: hiding merchandise
 * behind JS reads as a broken page (learned the hard way on PDP carousels).
 * Idempotent; safe to load twice. AJAX-injected nodes render unarmed. */
(function () {
  if (window.__islandMotion) return;
  window.__islandMotion = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTORS = [
    '[data-reveal]',
    '.iv__card',
    '.isg__material',
    '.isg__chip',
    '.isg__tip'
  ].join(',');

  function arm() {
    var nodes = document.querySelectorAll(SELECTORS);
    if (!nodes.length) return;

    var perParent = new Map();
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('im-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -4% 0px' });

    nodes.forEach(function (el) {
      if (el.classList.contains('im-armed')) return;
      var p = el.parentElement || document.body;
      var i = perParent.get(p) || 0;
      perParent.set(p, i + 1);
      el.style.setProperty('--ri', String(i % 5));
      el.classList.add('im-armed');
      io.observe(el);
    });

    // Safety net: nothing stays hidden longer than 2s no matter what
    // (observer quirks, background tabs, horizontal carousels).
    setTimeout(function () {
      document.querySelectorAll('.im-armed:not(.im-in)').forEach(function (el) {
        el.classList.add('im-in');
      });
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();
